export enum ProductFamily {
  FIBER = 'Fiber',
}

/**
 * Formats a string by removing the last character when duration is 1 (singular)
 * Useful for converting "months" to "month" or similar patterns
 * @param value - The string to format
 * @param duration - The duration value
 * @returns Formatted string with last char removed if duration === 1
 */
export const formatString = (value: string, duration: number): string => {
  return duration > 1 ? value : value.slice(0, -1);
};
